import { render, staticRenderFns } from "./platformTaskReview.vue?vue&type=template&id=06f8c25a&scoped=true"
import script from "./platformTaskReview.vue?vue&type=script&lang=js"
export * from "./platformTaskReview.vue?vue&type=script&lang=js"
import style0 from "./platformTaskReview.vue?vue&type=style&index=0&id=06f8c25a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f8c25a",
  null
  
)

export default component.exports